// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x7Qp","label":"styles_label__2hBix"};